import React from 'react';

const TabNavigation = ({ activeTab, setActiveTab }) => {
  const tabs = [
    { id: 'Logística', label: 'Logística', icon: '📦' },
    { id: 'RMA', label: 'RMA', icon: '🔄' },
    { id: 'Entregas', label: 'Entregas', icon: '🚚' },
    { id: 'Registros', label: 'Registros', icon: '📋' },
    { id: 'Registros RMA', label: 'Registros RMA', icon: '📊' }
  ];

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    
    // Auto-focus en campos principales según la pestaña seleccionada
    setTimeout(() => {
      if (tabId === 'Logística') {
        const skuInput = document.getElementById('sku-input');
        if (skuInput) skuInput.focus();
      } else if (tabId === 'RMA') {
        const rmaInput = document.getElementById('rma-input');
        if (rmaInput) rmaInput.focus();
      }
    }, 100);
  };

  return (
    <div className="tabs-container">
      {tabs.map(tab => (
        <button
          key={tab.id}
          className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => handleTabChange(tab.id)}
          aria-selected={activeTab === tab.id}
          role="tab"
          aria-controls={`${tab.id.toLowerCase()}-panel`}
        >
          <span className="tab-icon">{tab.icon}</span>
          <span className="tab-label">{tab.label}</span>
        </button>
      ))}
    </div>
  );
};

export default TabNavigation;